import { forwardRef, useState } from "react";
import styled from "@emotion/styled";
import { Tab, Tabs } from "@leafygreen-ui/tabs";
import { H3 } from "@leafygreen-ui/typography";
import { size } from "@evg-ui/lib/constants/tokens";
import ButtonRow from "./ButtonRow";
import CliCommandButton from "./CliCommandButton/CliCommandButton";
import SearchRangeInput from "./SearchRangeInput";
import {
  CaseSensitiveToggle,
  ExcludeTimestampsToggle,
  ExpandableRowsToggle,
  FilterLogicToggle,
  HighlightFiltersToggle,
  JumpToFailingLineToggle,
  PrettyPrintToggle,
  SectionsToggle,
  StickyHeadersToggle,
  WordWrapFormatToggle,
  WrapToggle,
  ZebraStripingToggle,
} from "./Toggles";

interface DetailsMenuProps {
  "data-testid"?: string;
}

const DetailsMenuCard = forwardRef<HTMLDivElement, DetailsMenuProps>(
  ({ "data-testid": dataTestId }, ref) => {
    const [selectedTab, setSelectedTab] = useState(0);

    return (
      <Container ref={ref} data-testid={dataTestId}>
        <H3>Parsley Settings</H3>
        <Tabs
          aria-label="Details Card Tabs"
          onValueChange={setSelectedTab}
          value={selectedTab}
        >
          <Tab data-testid="search-and-filter-tab" name="Search & Filter">
            <Row>
              <Column>
                <SearchRangeInput />
                <CaseSensitiveToggle />
                <FilterLogicToggle />
                <HighlightFiltersToggle />
              </Column>
            </Row>
            <ButtonRow />
            <CliCommandButton />
          </Tab>
          <Tab data-testid="log-viewing-tab" name="Log Viewing">
            <Row>
              <Column>
                <WrapToggle />
                <WordWrapFormatToggle />
                <PrettyPrintToggle />
                <ExpandableRowsToggle />
                <ZebraStripingToggle />
                <JumpToFailingLineToggle />
                <SectionsToggle />
                <StickyHeadersToggle />
                <ExcludeTimestampsToggle />
              </Column>
            </Row>
          </Tab>
        </Tabs>
      </Container>
    );
  },
);
DetailsMenuCard.displayName = "DetailsMenuCard";

const Container = styled.div`
  padding: ${size.xs};
  display: flex;
  flex-direction: column;
  gap: ${size.xxs};
  text-align: left;
  width: 500px;
`;

const Row = styled.div`
  padding-top: ${size.s};
`;
const Column = styled.div`
  width: 100%;
`;

export default DetailsMenuCard;
